<template>
  <svg
    v-if="!props.active"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.85986 7.92914C4.85986 6.23915 6.22987 4.86914 7.91986 4.86914C9.60985 4.86914 10.9799 6.23915 10.9799 7.92914V16.0891C10.9799 17.7791 9.60985 19.1491 7.91986 19.1491C6.22987 19.1491 4.85986 17.7791 4.85986 16.0891V7.92914Z"
      stroke="#4D4D4D"
      stroke-width="1.5"
      stroke-linecap="square"
      stroke-linejoin="round" />
    <path
      d="M13.5298 7.67414C13.5298 6.12498 14.7856 4.86914 16.3348 4.86914C17.8839 4.86914 19.1398 6.12498 19.1398 7.67414V10.2241C19.1398 11.7733 17.8839 13.0291 16.3348 13.0291C14.7856 13.0291 13.5298 11.7733 13.5298 10.2241V7.67414Z"
      stroke="#4D4D4D"
      stroke-width="1.5"
      stroke-linecap="square"
      stroke-linejoin="round" />
    <path
      d="M16.5899 21.1898V16.0898M19.14 18.6449L14.04 18.6449"
      stroke="#333333"
      stroke-width="1.5" />
    <circle
      cx="21.1802"
      cy="3.85008"
      r="0.51"
      fill="#666666"
      stroke="#333333"
      stroke-width="1.02" />
    <path
      d="M2.81934 2.32031C3.101 2.32031 3.33008 2.54939 3.33008 2.83105C3.32984 3.11251 3.10085 3.34082 2.81934 3.34082C2.53804 3.34057 2.30981 3.11236 2.30957 2.83105C2.30957 2.54955 2.53789 2.32057 2.81934 2.32031Z"
      fill="#666666"
      stroke="#333333"
      stroke-width="1.02" />
  </svg>
  <svg
    v-else
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3669_9622)">
      <path
        d="M4.85986 7.90961C4.85986 6.21962 6.22987 4.84961 7.91986 4.84961C9.60985 4.84961 10.9799 6.21962 10.9799 7.90961V16.0696C10.9799 17.7596 9.60985 19.1296 7.91986 19.1296C6.22987 19.1296 4.85986 17.7596 4.85986 16.0696V7.90961Z"
        fill="url(#paint0_linear_3669_9622)"
        stroke="#8F42FE"
        stroke-width="1.53"
        stroke-linecap="square"
        stroke-linejoin="round" />
      <path
        d="M4.85986 7.90961C4.85986 6.21962 6.22987 4.84961 7.91986 4.84961C9.60985 4.84961 10.9799 6.21962 10.9799 7.90961V16.0696C10.9799 17.7596 9.60985 19.1296 7.91986 19.1296C6.22987 19.1296 4.85986 17.7596 4.85986 16.0696V7.90961Z"
        stroke="#8F42FE"
        stroke-width="1.5"
        stroke-linecap="square"
        stroke-linejoin="round" />
      <path
        d="M13.5298 7.65461C13.5298 6.10545 14.7856 4.84961 16.3348 4.84961C17.8839 4.84961 19.1398 6.10545 19.1398 7.65461V10.2046C19.1398 11.7538 17.8839 13.0096 16.3348 13.0096C14.7856 13.0096 13.5298 11.7538 13.5298 10.2046V7.65461Z"
        fill="url(#paint1_linear_3669_9622)" />
      <path
        d="M13.5298 7.65461C13.5298 6.10545 14.7856 4.84961 16.3348 4.84961C17.8839 4.84961 19.1398 6.10545 19.1398 7.65461V10.2046C19.1398 11.7538 17.8839 13.0096 16.3348 13.0096C14.7856 13.0096 13.5298 11.7538 13.5298 10.2046V7.65461Z"
        stroke="#8F42FE"
        stroke-width="1.5"
        stroke-linecap="square"
        stroke-linejoin="round" />
      <g clip-path="url(#paint2_diamond_3669_9622_clip_path)" data-figma-skip-parse="true">
        <g transform="matrix(0 0.00459 -0.00459 0 16.59 18.6193)">
          <rect
            x="0"
            y="0"
            width="1222.22"
            height="1222.22"
            fill="url(#paint2_diamond_3669_9622)"
            opacity="1"
            shape-rendering="crispEdges" />
          <rect
            x="0"
            y="0"
            width="1222.22"
            height="1222.22"
            transform="scale(1 -1)"
            fill="url(#paint2_diamond_3669_9622)"
            opacity="1"
            shape-rendering="crispEdges" />
          <rect
            x="0"
            y="0"
            width="1222.22"
            height="1222.22"
            transform="scale(-1 1)"
            fill="url(#paint2_diamond_3669_9622)"
            opacity="1"
            shape-rendering="crispEdges" />
          <rect
            x="0"
            y="0"
            width="1222.22"
            height="1222.22"
            transform="scale(-1)"
            fill="url(#paint2_diamond_3669_9622)"
            opacity="1"
            shape-rendering="crispEdges" />
        </g>
      </g>
      <circle
        cx="16.59"
        cy="18.6193"
        r="4.59"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.85098040103912354,&#34;g&#34;:0.85098040103912354,&#34;b&#34;:0.85098040103912354,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.85098040103912354,&#34;g&#34;:0.85098040103912354,&#34;b&#34;:0.85098040103912354,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:5.6211292783590471e-16,&#34;m01&#34;:-9.1800003051757812,&#34;m02&#34;:21.180000305175781,&#34;m10&#34;:9.1800003051757812,&#34;m11&#34;:5.6211292783590471e-16,&#34;m12&#34;:14.0292968750},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}" />
      <path
        d="M16.5899 21.1684V16.0684M19.14 18.6235L14.04 18.6235"
        stroke="white"
        stroke-width="1.5" />
      <g filter="url(#filter0_d_3669_9622)">
        <circle cx="21.1802" cy="3.83055" r="1.02" fill="white" />
        <circle cx="21.1802" cy="3.83055" r="0.51" stroke="white" stroke-width="1.02" />
      </g>
      <g filter="url(#filter1_d_3669_9622)">
        <path
          d="M3.8398 2.80912C3.8398 3.37245 3.38314 3.82912 2.8198 3.82912C2.25647 3.82912 1.7998 3.37245 1.7998 2.80912C1.7998 2.24579 2.25647 1.78912 2.8198 1.78912C3.38314 1.78912 3.8398 2.24579 3.8398 2.80912Z"
          fill="white" />
        <path
          d="M2.81934 2.29883C3.101 2.29883 3.33008 2.52791 3.33008 2.80957C3.32984 3.09103 3.10085 3.31934 2.81934 3.31934C2.53804 3.31908 2.30981 3.09087 2.30957 2.80957C2.30957 2.52806 2.53789 2.29908 2.81934 2.29883Z"
          stroke="white"
          stroke-width="1.02" />
      </g>
    </g>
    <defs>
      <clipPath id="paint2_diamond_3669_9622_clip_path">
        <circle cx="16.59" cy="18.6193" r="4.59" />
      </clipPath>
      <filter
        id="filter0_d_3669_9622"
        x="18.1202"
        y="0.770547"
        width="6.12004"
        height="6.11906"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1.02" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3669_9622" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3669_9622"
          result="shape" />
      </filter>
      <filter
        id="filter1_d_3669_9622"
        x="-0.240195"
        y="-0.250937"
        width="6.12004"
        height="6.12102"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1.02" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3669_9622" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3669_9622"
          result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_3669_9622"
        x1="7.91986"
        y1="11.9896"
        x2="3.96607"
        y2="13.6841"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" stop-opacity="0" />
        <stop offset="1" stop-color="#8F42FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3669_9622"
        x1="16.3348"
        y1="8.92961"
        x2="13.4217"
        y2="10.9324"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" stop-opacity="0" />
        <stop offset="1" stop-color="#8F42FF" />
      </linearGradient>
      <linearGradient
        id="paint2_diamond_3669_9622"
        x1="0"
        y1="0"
        x2="500"
        y2="500"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#D9D9D9" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_3669_9622">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});
</script>
